<template>
  <div class="panorama-control">
    <panorama-ui-select
        style="z-index: 5"
        :items="$panorama.control.categories"
        :value="activeCategory"
        @input="changeCategory"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import PanoramaUiSelect from '@/components/ui/PanoramaUiSelect'

const { mapState, mapMutations } = createNamespacedHelpers('Panorama/Control')

export default {
  name: 'PanoramaControl',
  components: {
    PanoramaUiSelect
  },
  computed: {
    ...mapState([
      'activeGroup',
      'activeCorpus',
      'activeFloor',
      'activeCategory'
    ]),
    corps () {
      return this.$panorama.structure.corpsView.map(item => item.name)
    },
    floors () {
      if (this.$panorama.structure.corpsView[this.activeCorpus].floors[0].floor === 0) return []
      return this.$panorama.structure.corpsView[this.activeCorpus].floors.map(item => 'Этаж ' + item.floor)
    }
  },
  methods: {
    ...mapMutations([
      'SET_ACTIVE_GROUP',
      'SET_ACTIVE_CORPUS',
      'SET_ACTIVE_FLOOR',
      'SET_ACTIVE_CATEGORY'
    ]),
    changeCategory (newCategory) {
      this.SET_ACTIVE_CATEGORY(newCategory)
      this.SET_ACTIVE_CORPUS(0)
      this.SET_ACTIVE_FLOOR(0)
      this.SET_ACTIVE_GROUP(0)
    },
    changeFloor (newFloorIndex) {
      this.SET_ACTIVE_FLOOR(this.$panorama.structure.corpsView[this.activeCorpus].floors[newFloorIndex].floor)
    }
  }
}
</script>

<style lang="scss">
.panorama-control {
  &__floor.ui-select {
    width: unset;
    .ui-select__item {
      display: flex;
    }
  }
  & > .ui-select {
    margin-bottom: 10px;
  }
}
@media screen and (min-width: 768px) {
  .panorama-control {
    &__floor.ui-select {
      width: 70px;
      .ui-select__item {
        width: 100%;
        justify-content: center;
      }
    }
  }
}

@media screen and (min-width: 1920px) {
  .panorama-control {
    &__floor.ui-select {
      min-width: 70px;
      width: 3.5vw;
      .ui-select__item {
        min-width: 70px;
        width: 100%;
        justify-content: center;
      }
    }
    & > .ui-select {
      margin-bottom: 0.5vw;
    }
  }
}
</style>
